import React from 'react'
import { Typography } from '@mui/material'
import { toLocale } from '$func/text'

const digit2converter = (number: number) => `${number > 9 ? '' : '0'}${number}`

const formatter = (duration: number, withDeci: boolean) => {
  const date = new Date(duration)
  const minutes = date.getUTCMinutes()
  const seconds = digit2converter(date.getUTCSeconds())
  const deciSeconds = Math.round(date.getUTCMilliseconds() / 100)

  return withDeci
    ? toLocale(`${minutes}:${seconds}.${deciSeconds}`)
    : toLocale(`${minutes}:${seconds}`)
}

export function durationLabelRenderer(
  duration: number,
  variant: 'subtitle1' | 'subtitle3' = 'subtitle1',
  color: 'gray' | 'neutral700' = 'gray',
  withDeci = true,
) {
  return (
    <Typography variant={variant} color={color}>
      {formatter(duration, withDeci)}
    </Typography>
  )
}
